export default {
  title: {
    id: 'product_comparison_suggested_categories_title',
    defaultMessage: 'Other categories',
  },
} as const
